import Decimal from "decimal.js";

// One Decimal configuration for every quantity in the system: 3-decimal storage precision is a
// database rule (numeric(14,3)); arithmetic here is exact and only the DB/UI boundary rounds.
Decimal.set({ precision: 28, rounding: Decimal.ROUND_HALF_UP });

export { Decimal };
export type DecimalInput = Decimal.Value | null | undefined;

/** Coerce a payload value to Decimal, treating null/blank/garbage as 0 (mirrors vnr-prod `to_decimal`). */
export function toDecimal(value: DecimalInput): Decimal {
  if (value === null || value === undefined || value === "")
    return new Decimal(0);
  try {
    const d = new Decimal(value);
    return d.isFinite() ? d : new Decimal(0);
  } catch {
    return new Decimal(0);
  }
}

export const ZERO = new Decimal(0);
